/* Functional navigation context. No customer, email or personalization data. */
(() => {
  const key = 'lpm-navigation-v1';
  const ttl = 30 * 60 * 1000;
  const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const pt = document.documentElement.lang.toLowerCase().startsWith('pt');
  const locale = document.documentElement.lang;
  const relative = url => url.pathname + url.search + url.hash;
  const path = value => new URL(value, location.origin).pathname.replace(/\/$/, '');
  const cleanPath = value => path(value).replace(/^\/pt-pt(?=\/|$)/i, '');
  const productPath = value => cleanPath(value).match(/\/products\/[^/]+$/)?.[0];
  const read = () => { try { const s = JSON.parse(sessionStorage.getItem(key)); return s && s.locale === locale && Date.now() - s.time < ttl ? s : null; } catch { return null; } };
  const write = value => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch {} };
  function kind() {
    const p = cleanPath(location.href);
    if (p.includes('/products/')) return null;
    if (/^\/collections\/[^/]+$/.test(p)) return 'collection';
    if (p === '/search' || p === '/pages/search-results-page') return 'search';
    if (/^\/pages\/quiz(?:-regalo|-personal)?$/.test(p)) return 'quiz';
    if (p === '/pages/guia-joyas-personalizadas') return 'guide';
    return null;
  }
  function track(action, extra = {}) {
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
    // Paths only: search terms, UTM and personalization never enter these events.
    const data = {action, locale, source: cleanPath(location.href), ...extra};
    window.Shopify?.analytics?.publish?.('lpm_navigation', data);
    if (typeof window.gtag === 'function') window.gtag('event', 'lpm_navigation_' + action, data);
  }
  function localize(anchor) {
    if (!pt || anchor.hasAttribute('hreflang') || anchor.closest('localization-form,[data-localization-form]') || !anchor.getAttribute('href') || anchor.getAttribute('href').startsWith('#')) return;
    try {
      const url = new URL(anchor.getAttribute('href'), location.origin);
      if (url.origin !== location.origin || !/^\/(collections|products|pages|blogs|policies|search|cart)(\/|$)/.test(url.pathname)) return;
      url.pathname = root.replace(/\/$/, '') + url.pathname;
      anchor.setAttribute('href', relative(url));
    } catch {}
  }
  const localizeTree = node => {
    if (node.nodeType !== 1) return;
    if (node.matches('a[href]')) localize(node);
    node.querySelectorAll('a[href]').forEach(localize);
  };
  function updateLanguageLink(anchor) {
    const url = new URL(anchor.href); url.search = location.search; url.hash = location.hash; anchor.href = relative(url);
  }
  document.querySelectorAll('[data-language-link]').forEach(updateLanguageLink);
  localizeTree(document.documentElement);
  if (pt) new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') localize(record.target);
      else record.addedNodes.forEach(localizeTree);
    }
  }).observe(document.body, {subtree:true, childList:true, attributes:true, attributeFilter:['href']});

  document.addEventListener('click', event => {
    const anchor = event.target.closest('a[href]');
    if (!anchor) return;
    if (anchor.matches('[data-language-link]')) updateLanguageLink(anchor);
    localize(anchor);
    let url; try { url = new URL(anchor.href); } catch { return; }
    if (url.origin !== location.origin) return;
    if (anchor.matches('[data-navigation-return]')) track('return', {destination:cleanPath(url.href)});
    const sourceKind = kind();
    if (!sourceKind || !productPath(url.href) || !anchor.closest('main') || anchor.closest('header,footer')) return;
    write({time:Date.now(), locale, kind:sourceKind, source:relative(new URL(location.href)), target:productPath(url.href), scroll:scrollY});
    track('product_open', {destination:productPath(url.href), source_kind:sourceKind, filtered:location.search.includes('filter.')});
  }, true);

  function restore() {
    const saved = read();
    if (!saved) return;
    const navType = performance.getEntriesByType('navigation')[0]?.type;
    const referrer = document.referrer ? new URL(document.referrer) : null;
    const current = relative(new URL(location.href));
    if (saved.source === current && (navType === 'back_forward' || (referrer?.origin === location.origin && productPath(referrer.href) === saved.target))) {
      if (!document.querySelector('lpm-jewelry-quiz,[data-personalization-guide]')) requestAnimationFrame(() => scrollTo({top:saved.scroll || 0,behavior:'instant'}));
      track('restored', {source_kind:saved.kind});
    }
    if (productPath(location.href) !== saved.target) return;
    const sourceUrl = new URL(saved.source, location.origin);
    if (sourceUrl.origin !== location.origin) return;
    const validReferrer = referrer?.origin === location.origin && path(referrer.href) === path(sourceUrl.href);
    if (!validReferrer && !['reload','back_forward'].includes(navType)) {
      try { sessionStorage.removeItem(key); } catch {}
      return;
    }
    const nav = document.querySelector('[data-breadcrumbs]');
    if (!nav || nav.querySelector('[data-navigation-return]')) return;
    const link = document.createElement('a');
    link.href = saved.source; link.className = 'breadcrumbs__link'; link.dataset.navigationReturn = '';
    link.textContent = pt ? '← Voltar à seleção' : '← Volver a la selección';
    link.style.cssText = 'font-size:11px;text-transform:none;white-space:nowrap;display:inline-flex;align-items:center;flex-shrink:0';
    nav.appendChild(link);
  }
  restore();
  window.addEventListener('pageshow', event => { if (event.persisted) restore(); });
})();
